export const modalCloseConfirm = {
	question: 'Are you sure you want to close the form without saving?',
	children: 'Your current changes will be lost.',
};

export const MODAL_WIDTH_375 = '375px';
export const MODAL_WIDTH_400 = '400px';
export const MODAL_WIDTH_455 = '455px';
export const MODAL_WIDTH_480 = '480px';
export const MODAL_WIDTH_500 = '500px';
export const MODAL_WIDTH_580 = '580px';
export const MODAL_WIDTH_772 = '772px';
export const MODAL_WIDTH_880 = '880px';
export const MODAL_WIDTH_1000 = '1000px';
